import Vue from "vue";

/**
 * Lista eventi gestiti:
 * - print: notifica che è richiesta un operazione di stampa della configurazione
 * - share: notifica che è richiesta un operazione di condivisione della configurazione
 */

export const EventBus = new Vue();
